import DropdownMenu from '@/components/DropdownMenu';
import { faXmarkCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from 'components/tooltip/Tooltip';
import { TruncatedText } from 'components/TruncatedText';
import PluginIcon from 'pages/scope/PluginIcon';
import { useAvailableDataStreamDefinitionsForWorkspace } from 'queries/hooks/useAvailableDataStreamDefinitionsForWorkspace';
import { useRef } from 'react';
import { useSplashScreenDataStreamSelect } from '../hooks/useSplashScreenDataStreamSelect';
import { TileEditorDataStreams } from '../state/useTileEditorDataStreams';
import { SplashScreenDatasourceErrorText } from './SplashScreenDatasourceErrorText';
import { SplashScreenDataSource } from './useSplashScreenDatasources';

interface SplashScreenOptionsDropdownOptionProps extends SplashScreenDataSource {
    dataStreams: NonNullable<ReturnType<typeof useAvailableDataStreamDefinitionsForWorkspace>['data']>;
    tileEditorDataStreams: TileEditorDataStreams;
}

export const SplashScreenOptionsDropdownOption: React.FC<SplashScreenOptionsDropdownOptionProps> = ({
    id,
    name,
    failedImports,
    dataStreams,
    tileEditorDataStreams
}) => {
    const { selectDatasource } = useSplashScreenDataStreamSelect(id, dataStreams, tileEditorDataStreams);
    const disabled = failedImports && failedImports.length > 0;
    const importStatusIconRef = useRef<SVGSVGElement | null>(null);

    const dropdownItem = (
        <DropdownMenu.Item
            key={id}
            onSelect={() => selectDatasource()}
            icon={<PluginIcon pluginName={name} className='w-7 h-7' />}
            className='text-nowrap'
            data-testid={`splashDatasourceBtn-${name}`}
            disabled={disabled}
        >
            <span className='flex gap-3'>
                <TruncatedText title={name} className='items-center min-w-0' />
            </span>
        </DropdownMenu.Item>
    );

    if (!disabled) {
        return dropdownItem;
    }

    return (
        <Tooltip
            title={<SplashScreenDatasourceErrorText failedImports={failedImports} />}
            placement='top-start'
            className='flex items-center justify-between pr-3 gap-x-2'
            referenceElement={importStatusIconRef.current}
        >
            {dropdownItem}
            <FontAwesomeIcon
                icon={faXmarkCircle}
                className='size-[18px] text-statusErrorPrimary'
                ref={importStatusIconRef}
            />
        </Tooltip>
    );
};
